<!-- Notification Center Dropdown Panel using Flowbite -->
<div 
  *ngIf="isOpen" 
  #notificationDropdown
  class="absolute right-0 mt-2 w-80 md:w-96 max-w-[calc(100vw-1rem)] bg-white rounded-lg shadow-xl dark:bg-gray-800 dark:border dark:border-gray-700 z-50 overflow-hidden"
>
  <!-- Header -->
  <div class="px-4 py-3 bg-gray-50 border-b border-gray-200 dark:bg-gray-700 dark:border-gray-600 flex justify-between items-center sticky top-0 z-10">
    <h3 class="text-sm font-medium text-gray-700 dark:text-white">
      Notifications
      <span *ngIf="unreadCount > 0" class="ml-1 text-xs py-0.5 px-1.5 bg-blue-100 text-blue-800 rounded-full dark:bg-blue-900 dark:text-blue-100">
        {{ unreadCount }}
      </span>
    </h3>
    <div class="flex space-x-1">
      <button 
        *ngIf="unreadCount > 0"
        (click)="markAllAsRead()" 
        type="button" 
        class="text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 flex items-center"
      >
        <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
        </svg>
        Mark all as read
      </button>
    </div>
  </div>
  
  <!-- Notification Body -->
  <div class="overflow-y-auto max-h-[calc(80vh-8rem)]" style="scrollbar-width: thin;">
    <!-- Loading State -->
    <div *ngIf="loading" class="flex justify-center items-center p-6">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-500 dark:border-blue-400"></div>
    </div>
    
    <!-- Error State -->
    <div *ngIf="error && !loading" class="p-6 text-center">
      <div class="text-red-500 dark:text-red-400 mb-3">
        <svg class="w-8 h-8 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
      </div>
      <p class="text-sm text-gray-600 dark:text-gray-300">Failed to load notifications</p>
      <button 
        (click)="retryLoad()" 
        class="mt-2 text-xs text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
      >
        Try again
      </button>
    </div>
    
    <!-- Empty State -->
    <div *ngIf="!loading && !error && visibleNotifications.length === 0" class="flex flex-col items-center justify-center p-10 text-center">
      <div class="mb-4">
        <svg class="w-16 h-16 mx-auto text-blue-200 dark:text-blue-900" fill="none" stroke="currentColor" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M24 4v4m0 32v4m20-20h-4M8 24H4m30.36-13.36l-2.83 2.83M13.36 34.64l-2.83 2.83m0-22.62l2.83 2.83M34.64 34.64l2.83 2.83"/>
          <circle cx="24" cy="24" r="10" stroke="currentColor" stroke-width="2.5" fill="none"/>
        </svg>
      </div>
      <h4 class="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-2">You're all caught up!</h4>
      <p class="text-sm text-gray-500 dark:text-gray-400 mb-2">You have no new notifications right now.</p>
      <p class="text-xs text-gray-400 dark:text-gray-500">Check back later or explore other features in the app.</p>
    </div>
    
    <!-- Notifications List -->
    <div class="divide-y divide-gray-100 dark:divide-gray-700">
      <ng-container *ngIf="!loading && !error && notifications.length > 0">
        <app-notification-item 
          *ngFor="let notification of visibleNotifications" 
          [notification]="notification"
          (actionClick)="handleAction($event.notification, $event.actionType)"
          (toggleReadStatus)="toggleRead($event)"
          (archiveNotification)="archiveNotification($event)"
          (notificationClick)="handleNotificationClick($event)"
          [clickable]="!!hasRouteData(notification) || !!notification.redirect"
          [loadingPrimary]="loadingPrimaryId === notification.id"
          [loadingSecondary]="loadingSecondaryId === notification.id"
          class="block"
        >
        </app-notification-item>
      </ng-container>
    </div>
  </div>
  
  <!-- Footer -->
  <!-- <div *ngIf="notifications.length > 5" class="px-4 py-2 bg-gray-50 border-t border-gray-200 dark:bg-gray-700 dark:border-gray-600 text-center">
    <a href="#" class="text-xs text-blue-600 dark:text-blue-400 hover:underline">
      View all notifications
    </a>
  </div> -->
</div>
